export default __webpack_public_path__ + "static/hbg-9-4f62f5c1b3e0373c3eaf5aef8cbafb50.jpg";